import type { RequestType } from "@entities";

/** Resolves managerId for save - never falls back to currentUser when managerId is already set. */
export function resolveOpportunityManagerId(
  request: Pick<RequestType, "manager" | "managerId">,
  currentUser?: { id: string } | null,
): string {
  return (
    request.manager?.id ||
    request.managerId ||
    currentUser?.id ||
    ""
  );
}
